import React, { useRef, Fragment, useState, useEffect } from "react";
import html2pdf from "html2pdf.js";
import style from "../../styles/pdf.module.scss";
import { Link, useParams } from "react-router-dom";
import LoaderComponent from "../../components/LoaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import stylebtn from "../../styles/btn.module.scss";
import { obtenerDetalleventaR } from "../../api/ApiVenta";
import { useFormatter } from "../../hooks/useFormatter";
import ParrafoComponent from "../../components/ParrafoComponent";
import { useFechaActual } from "../../hooks/useFechaActual";

const PdfVentaR = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const contentRefs = useRef([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [currentCliente, setCurrentCliente] = useState([]);
  const [currentFactura, setCurrentFactura] = useState([]);
  const [currentFacturaDF, setCurrentFacturaDF] = useState([]);
  const { formatDate, formatDateUTC } = useFormatter();
  const { calcularDiferenciaDias } = useFechaActual();
  const fechVentaRapida = async () => {
    try {
      const factura = await obtenerDetalleventaR(id);
      setCurrentFactura(factura?.res?.data);
      setCurrentCliente(factura?.res?.data);

      const mergedProducts = (
        factura?.res?.data?.ventaRapidaDetalles || []
      ).reduce((acc, current) => {
        // Buscar si ya existe un producto con la misma clase, tipo y dimensión
        const existingProduct = acc.find(
          (item) => item?.producto === current.producto
        );

        if (existingProduct) {
          // Si existe, sumamos la cantidad y recalculamos el precio total
          existingProduct.cantidad += current.cantidad;
          existingProduct.pendiente_entrega += current.pendiente_entrega;
          existingProduct.subtotal =
            Number(existingProduct.subtotal) + Number(current.subtotal);
        } else {
          // Si no existe, lo añadimos al array acumulador
          acc.push({ ...current });
        }

        return acc;
      }, []);

      const partitionArray = (array, size) => {
        const partitioned = [];
        for (let i = 0; i < array.length; i += size) {
          partitioned.push(array.slice(i, i + size));
        }
        return partitioned;
      };

      const partitionedProducts = partitionArray(mergedProducts, 7);
      setCurrentFacturaDF(partitionedProducts);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fechVentaRapida();
    }
  }, [id]);

  const handleGeneratePdf = () => {
    // Crear un div temporal para combinar todo el contenido
    const element = document.createElement("div");
    contentRefs.current.forEach((ref) => {
      if (ref) {
        element.appendChild(ref.cloneNode(true)); // Clona y agrega cada ref al div temporal
      }
    });

    // Generar el PDF y convertirlo a Blob
    html2pdf()
      .from(element)
      .toPdf()
      .output("blob")
      .then((pdfBlob) => {
        // Crear una URL para mostrar el PDF
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url);
      });
  };

  useEffect(() => {
    if (currentFacturaDF.length > 0) {
      setTimeout(() => {
        handleGeneratePdf();
      }, 500);
    }
  }, [currentFacturaDF]);

  // Dirección de envío propia de esta venta; si no se registró una puntual,
  // cae a la dirección del cliente. Se usa la misma expresión tanto para
  // decidir si se muestra la sección como para el texto que se imprime, así
  // no queda "vacía pero visible" ni "con dato pero oculta".
  const direccionEnvio =
    currentCliente?.direccion || currentCliente?.Cliente?.Persona?.direccion;

  return (
    <Fragment>
      {loading ? (
        <LoaderComponent styleGroup="mt-5" />
      ) : (
        <div>
          {currentFacturaDF.map((group, index) => {
            return (
              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className={`${index > 0 ? `${style.nuevapagina}` : ""} ${
                  style.container_pdf
                } `}
                key={index}
              >
                <TitleH2Component styleGroup=" color-dark fw700 roboto mb-2 text-center">
                  COMPRAVENTA DE MADERAS EL PACA
                </TitleH2Component>
                <ParrafoComponent styleGroup=" color-dark fw700 roboto mb-2 text-center">
                  NIT. 11.172.739-1
                </ParrafoComponent>
                <ParrafoComponent styleGroup=" color-dark fw700 roboto mb-2 text-center">
                  Compra y venta de toda clase de maderas: maderas elaboradas,
                  machimbre, tablas, listones y tablillas para piso.
                </ParrafoComponent>
                <div className="d-flex align-items-start justify-content-between fw700">
                  <div>
                    FECHA DE FACTURA
                    <div className={style.caja_fecha}>
                      {currentFactura?.fecha_creacion
                        ? formatDateUTC(currentFactura?.fecha_creacion)
                        : formatDate(currentFactura.createdAt)}{" "}
                    </div>
                    {currentFactura?.fecha_vencimiento && (
                      <div className="mt-2">
                        FECHA DE VENCIMIENTO
                        <div className={`${style.caja_fecha}`}>
                          {formatDateUTC(currentFactura?.fecha_vencimiento)}
                        </div>
                        {/* Calcular y mostrar el plazo */}
                        <p>
                          Plazo:
                          {calcularDiferenciaDias(
                            currentFactura?.fecha_vencimiento,
                          ) > 0
                            ? ` ${calcularDiferenciaDias(currentFactura?.fecha_vencimiento)} dias`
                            : " Vencida"}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="text-center">
                    Cra 5 No. 27-07 <br /> Barrio San Roque <br /> Moñitos
                    Córdoba <br /> 3012222358
                  </div>

                  <div>
                    FACTURA DE VENTA
                    <div className={style.caja_fecha}>
                      N° {currentFactura?.numeroFactura}
                    </div>
                  </div>
                </div>
                <div className={`${style.card_cliente}`}>
                  <div className={`${style.card_documento}`}>
                    <p>
                      N Documento:{" "}
                      {currentCliente?.cedula ||
                        currentCliente?.Cliente?.Persona?.cedula}
                    </p>
                    <div className={`${style.linea}`}></div>
                    <p>
                      Cliente:{" "}
                      {currentCliente?.nombre ||
                        currentCliente?.Cliente?.Persona?.nombre}{" "}
                      {currentCliente?.apellido ||
                        currentCliente?.Cliente?.Persona?.apellido}
                    </p>
                  </div>
                  <div className={`${style.card_direccion}`}>
                    <p>
                      Direccion:{" "}
                      {currentCliente?.Cliente?.Persona?.direccion}
                    </p>
                  </div>
                  <div className={`${style.card_celular}`}>
                    <p>
                      Celular:{" "}
                      {currentCliente?.telefono ||
                        currentCliente?.Cliente?.Persona?.celular}
                    </p>
                  </div>
                </div>
                {currentCliente.nombre_conductor && (
                  <div className={`${style.card_cliente}`}>
                    <div className={`${style.card_documento_center}`}>
                      <p>Transportador: {currentCliente?.nombre_conductor}</p>
                      <div className={`${style.linea}`}></div>
                      <p>Celular: {currentCliente?.celular_conductor}</p>
                    </div>
                  </div>
                )}
                <table className={`${style.styled_table}`}>
                  <thead>
                    <tr>
                      <th colSpan={currentCliente?.tipo === "venta" ? 1 : 2}>
                        CANT.
                      </th>
                      <th colSpan={currentCliente?.tipo === "venta" ? 1 : 2}>
                        DESCRIPCIÓN
                      </th>
                      {currentCliente?.tipo === "venta" && <th>PENDIENTE</th>}
                      {currentCliente?.tipo === "venta" && <th>ENTREGADOS</th>}
                      <th>VAL. UNID</th>
                      <th>VAL. TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(group) && group.length > 0 ? (
                      group.map((item, index) => (
                        <tr key={index}>
                          <td
                            colSpan={currentCliente?.tipo === "venta" ? 1 : 2}
                            className={`${style.empty_row}`}
                          >
                            {item?.cantidad}
                          </td>
                          <td
                            colSpan={currentCliente?.tipo === "venta" ? 1 : 2}
                            className={`${style.empty_row}`}
                          >
                            {item?.producto}
                          </td>
                          {currentCliente?.tipo === "venta" && (
                            <td className={`${style.empty_row}`}>
                              {item?.pendiente_entrega}
                            </td>
                          )}
                          {currentCliente?.tipo === "venta" && (
                            <td className={`${style.empty_row}`}>
                              {" "}
                              {Number(item?.cantidad) -
                                Number(item?.pendiente_entrega)}
                            </td>
                          )}
                          <td className={`${style.empty_row}`}>
                            ${" "}
                            {Number(item?.precioUnidad).toLocaleString("es-ES")}
                          </td>
                          <td className={`${style.empty_row}`}>
                            $ {Number(item?.subtotal).toLocaleString("es-ES")}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className={`${style.empty_row}`}>
                          No hay facturas disponibles
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {Array.isArray(group) && group.length > 0 && (
                    <tfoot>
                      {currentFactura.transporte > 0 && (
                        <tr>
                          <td
                            colSpan="1"
                            className={
                              currentCliente?.tipo === "cotizacion" ||
                              currentCliente?.tipo === "elaboracion"
                                ? style.notBorderR
                                : ""
                            }
                          ></td>
                          <td
                            colSpan="1"
                            className={
                              currentCliente?.tipo === "cotizacion" ||
                              currentCliente?.tipo === "elaboracion"
                                ? style.notBorderL
                                : ""
                            }
                          ></td>
                          <td
                            colSpan="1"
                            className={
                              currentCliente?.tipo === "cotizacion" ||
                              currentCliente?.tipo === "elaboracion"
                                ? style.notBorderR
                                : ""
                            }
                          ></td>
                          <td
                            colSpan="1"
                            className={
                              currentCliente?.tipo === "cotizacion" ||
                              currentCliente?.tipo === "elaboracion"
                                ? style.notBorderL
                                : ""
                            }
                          ></td>
                          <td colSpan="1">Transporte</td>
                          <td>
                            $
                            {Number(
                              currentFactura?.transporte ?? 0,
                            ).toLocaleString("es-ES")}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td
                          colSpan="1"
                          className={
                            currentCliente?.tipo === "cotizacion" ||
                            currentCliente?.tipo === "elaboracion"
                              ? style.notBorderR
                              : ""
                          }
                        ></td>
                        <td
                          colSpan="1"
                          className={`${(currentCliente?.tipo === "cotizacion" || currentCliente?.tipo === "elaboracion") && style.notBorderL}`}
                        ></td>
                        <td
                          colSpan="1"
                          className={`${(currentCliente?.tipo === "cotizacion" || currentCliente?.tipo === "elaboracion") && style.notBorderR}`}
                        ></td>
                        <td
                          colSpan="1"
                          className={`${(currentCliente?.tipo === "cotizacion" || currentCliente?.tipo === "elaboracion") && style.notBorderL}`}
                        ></td>
                        <td colSpan="1">Subtotal</td>
                        <td>
                          $
                          {Number(
                            Number(currentFactura?.total) +
                              Number(currentFactura?.transporte ?? 0),
                          ).toLocaleString("es-ES")}
                        </td>
                      </tr>

                      {currentFactura?.estado !== 3 &&
                        (currentCliente?.tipo === "venta" ||
                          currentCliente?.tipo === "elaboracion") && (
                          <tr>
                            <td colSpan="1"></td>
                            <td colSpan="1"></td>
                            <td colSpan="1"></td>
                            <td colSpan="1"></td>
                            <td colSpan="1">Abono</td>
                            <td>
                              $
                              {Number(
                                currentFactura?.total_pagado ?? 0,
                              ).toLocaleString("es-ES")}
                            </td>
                          </tr>
                        )}

                      {currentFactura.descuento &&
                        currentFactura.descuento > 0 && (
                          <tr>
                            <td
                              colSpan="1"
                              className={
                                currentCliente?.tipo === "cotizacion" ||
                                currentCliente?.tipo === "elaboracion"
                                  ? style.notBorderR
                                  : ""
                              }
                            ></td>
                            <td
                              colSpan="1"
                              className={
                                currentCliente?.tipo === "cotizacion" ||
                                currentCliente?.tipo === "elaboracion"
                                  ? style.notBorderL
                                  : ""
                              }
                            ></td>
                            <td
                              colSpan="1"
                              className={
                                currentCliente?.tipo === "cotizacion" ||
                                currentCliente?.tipo === "elaboracion"
                                  ? style.notBorderR
                                  : ""
                              }
                            ></td>
                            <td
                              colSpan="1"
                              className={
                                currentCliente?.tipo === "cotizacion" ||
                                currentCliente?.tipo === "elaboracion"
                                  ? style.notBorderL
                                  : ""
                              }
                            ></td>
                            <td colSpan="1">Descuento</td>
                            <td>
                              $
                              {Number(
                                currentFactura?.descuento ?? 0,
                              ).toLocaleString("es-ES")}
                            </td>
                          </tr>
                        )}
                      {/*  <tr>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1"></td>
                        <td colSpan="1">Total</td>
                        <td>
                          $
                          {Number(
                            Number(currentFactura?.total ?? 0) +
                              Number(currentFactura?.transporte ?? 0) -
                              Number(currentFactura?.descuento)
                          ).toLocaleString("es-ES")}
                        </td>
                      </tr>*/}
                      <tr>
                        <td
                          colSpan="1"
                          className={`${(currentCliente?.tipo === "cotizacion" || currentCliente?.tipo === "elaboracion") && style.notBorderR}`}
                        ></td>
                        <td
                          colSpan="1"
                          className={`${(currentCliente?.tipo === "cotizacion" || currentCliente?.tipo === "elaboracion") && style.notBorderL}`}
                        ></td>
                        <td
                          colSpan="1"
                          className={`${(currentCliente?.tipo === "cotizacion" || currentCliente?.tipo === "elaboracion") && style.notBorderR}`}
                        >
                          <div className={`${style.cello}`}>
                            {currentFactura?.estado == 1 &&
                              (currentFactura.tipo === "venta" ||
                                currentFactura.tipo === "elaboracion") &&
                              "NO PAGA"}
                            {currentFactura?.estado == 2 &&
                              (currentFactura.tipo === "venta" ||
                                currentFactura.tipo === "elaboracion") &&
                              "PENDIENTE"}
                            {currentFactura?.estado == 0 &&
                              (currentFactura.tipo === "venta" ||
                                currentFactura.tipo === "elaboracion") &&
                              "PAGA"}
                            {currentFactura.tipo === "cotizacion" &&
                              "COTIZACION"}
                          </div>
                        </td>
                        <td
                          colSpan="1"
                          className={`${currentCliente?.tipo === "cotizacion" && style.notBorderL}`}
                        ></td>
                        {(currentCliente?.tipo === "venta" ||
                          currentCliente?.tipo === "elaboracion" ||
                          currentCliente?.tipo === "cotizacion") && (
                          <td colSpan="1">Pend. Pago</td>
                        )}
                        {(currentCliente?.tipo === "venta" ||
                          currentCliente?.tipo === "elaboracion" ||
                          currentCliente?.tipo === "cotizacion") && (
                          <td className="bg-success bg-opacity-75 text-white fw-bold">
                            {" "}
                            $
                            {currentFactura?.estado == 1
                              ? (
                                  Number(currentFactura?.total ?? 0) +
                                  Number(currentFactura?.transporte ?? 0) -
                                  Number(currentFactura?.descuento ?? 0) -
                                  Number(currentFactura?.total_pagado ?? 0)
                                ).toLocaleString("es-ES")
                              : 0}
                          </td>
                        )}
                      </tr>
                    </tfoot>
                  )}
                </table>
                <div
                  className={`d-flex align-items-center ${(currentFactura?.quien_recibe || direccionEnvio) ? "justify-content-between" : "justify-content-end"}`}
                >
                  {(currentFactura?.quien_recibe || direccionEnvio) && (
                    <div className="d-flex flex-column">
                      {currentFactura?.quien_recibe && (
                        <ParrafoComponent
                          styleGroup={`${style.firma} box-text fw700 color-darkroboto mb-1 mt-2`}
                        >
                          <span className={style.firma_label}>Quien recibe:</span>{" "}
                          {currentFactura?.quien_recibe}
                        </ParrafoComponent>
                      )}

                      {direccionEnvio && (
                        <ParrafoComponent
                          styleGroup={`${style.firma} box-text fw700 color-darkroboto mb-1 mt-2`}
                        >
                          <span className={style.firma_label}>Direccion de envio:</span>{" "}
                          {direccionEnvio}
                        </ParrafoComponent>
                      )}
                    </div>
                  )}

                  {/* Vendedor se mantiene a la derecha */}
                  <ParrafoComponent
                    styleGroup={`${style.firma} box-text fw700 color-darkroboto mb-1 mt-2`}
                  >
                    <span className={style.firma_label}>Vendedor:</span>{" "}
                    {currentFactura?.User?.nombre || currentFactura?.vendedor}
                  </ParrafoComponent>
                </div>
              </div>
            );
          })}

          {pdfUrl ? (
            <div className={`${style.viewpdf}`}>
              <embed
                src={pdfUrl}
                type="application/pdf"
                width="100%"
                height="600px"
                style={{ border: "1px solid black" }}
              />
              <Link
                to={
                  (currentFactura.tipo === "venta" || currentFactura.tipo === "elaboracion")
                    ? "/venta-realizadas"
                    : "/cotizaciones-realizadas"
                }
                className={`${style.btn_volver} ${stylebtn.btn} ${stylebtn.primary}`}
              >
                Ir a{" "}
                {(currentFactura.tipo === "venta" || currentFactura.tipo === "elaboracion") ? "Facturas" : "Cotizaciones"}
              </Link>
            </div>
          ) : (
            <LoaderComponent styleGroup="mt-5" />
          )}
        </div>
      )}
    </Fragment>
  );
};
export default PdfVentaR;
